import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UtentiApplicativiService {
  constructor(private http: HttpClient) {}
  baseUrl = 'api/UtenteApplicativo';
  list(): Observable<any> {
    return this.http.get(this.baseUrl + '/elenco');
  }
  get(id?: string) {
    return this.http.get(this.baseUrl + '/' + id);
  }
  post(item: any) {
    return this.http.post(this.baseUrl, item);
  }
  delete(id: number) {
    return this.http.delete(this.baseUrl + '/' + id);
  }
  attiva(id: number, item: any) {
    return this.http.patch(this.baseUrl + '/attiva/' + id, item);
  }
  disattiva(id: number, item: any) {
    return this.http.patch(this.baseUrl + '/disattiva/' + id, item);
  }
  ruoli() {
    return this.http.get('api/ruolo/elenco');
  }
}
